import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { ASSETS } from 'src/common/utils/config';
import styles from './styles.module.scss';
import { getRequest } from 'src/common/utils/api/request';
import { getDomainOrigin } from 'src/common/utils/serverConfig';
import { travelV2fUrls } from 'src/common/utils/api/urls';
import { VasViewEvents } from 'src/common/utils/segment/types';
import { sendVasEvents } from 'src/common/utils/segment';
import ItemIconElement from '../common/flag-Icon';

const Index = ({
  openDropdown = false,
  setOpenDropdown,
  searchResult,
  handleClick,
}) => {
  const [searchTerm, setSearchTerm] = useState(searchResult?.val?.name);
  const [countries, setCountries] = useState<any>([]);
  const [results, setResults] = useState<any>(countries);
  const dropdownRef = useRef<any>();

  useEffect(() => {
    getCountries();
    if (typeof window !== 'undefined')
      window.addEventListener('click', handleOutsideClick);
  }, []);

  useEffect(() => {
    if (openDropdown)
      sendVasEvents(VasViewEvents.VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION);
  }, [openDropdown]);

  useEffect(() => {
    if (!openDropdown && !!searchResult?.val)
      setSearchTerm(searchResult?.val?.name);
  }, [openDropdown, searchResult?.val]);

  useEffect(() => {
    if (!!countries) {
      const searchInput = searchTerm?.trim();

      if (!!searchInput) {
        const lowerCaseSearchTerm = searchInput?.toLowerCase();

        const updatedList = countries?.filter(({ name, code }) => {
          const lowerCaseName = name?.toLowerCase();
          const lowerCaseCode = code?.toLowerCase();

          return (
            lowerCaseName?.startsWith(lowerCaseSearchTerm) ||
            lowerCaseCode?.startsWith(lowerCaseSearchTerm)
          );
        });
        setResults(updatedList);
      } else setResults(countries);
    }
  }, [searchTerm, countries]);

  const getCountries = async () => {
    try {
      const res = await getRequest(
        `${getDomainOrigin()}${travelV2fUrls.getV2fCountries()}`
      );
      if (res) setCountries(res?.data?.data?.countries);
    } catch (error) {
      console.log({ error });
    }
  };

  const handleOutsideClick = (e: any) => {
    if (e.target?.contains(dropdownRef?.current)) {
      setOpenDropdown(false);
    }
  };

  return (
    <section
      ref={dropdownRef}
      onClick={handleOutsideClick}
      className={styles.inputContainer}
    >
      <input
        className={`${styles.countrySearchInput} ${
          openDropdown ? styles.inFocusStyles : ''
        }`}
        placeholder={'Where are you planning to go?'}
        type={'text'}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e?.target?.value)}
        name={'search term'}
        onClick={() => setOpenDropdown(true)}
      />
      <div className={styles.searchIcon}>
        <Image
          src={ASSETS.SEARCH_ICON}
          width={'16px'}
          height={'16px'}
          style={{ cursor: 'pointer' }}
        />
      </div>
      {searchTerm && (
        <div
          className={styles.clearIcon}
          onClick={() => {
            setSearchTerm('');
            handleClick({ country: '' });
          }}
        >
          <Image
            src={ASSETS.CLOSE_CROSS_MODAL}
            width={'18px'}
            height={'18px'}
            style={{ cursor: 'pointer' }}
          />
        </div>
      )}
      {openDropdown ? (
        <section className={styles.countryList}>
          <section className={styles.scrollView}>
            {results?.length > 0 &&
              results?.map((c: any) => (
                <div
                  className={styles.countryName}
                  key={c?.code}
                  onClick={() => {
                    handleClick({ country: c?.code });
                    setOpenDropdown(false);
                    setSearchTerm(c?.name);
                  }}
                >
                  <div className={styles.item}>
                    <ItemIconElement item={c} />
                    <div>{c?.name}</div>
                  </div>
                </div>
              ))}
            {results?.length === 0 && (
              <div className={styles.errorMessage}>
                {`No results found ${!!searchTerm ? 'for' : ''}`}
                <b>{!!searchTerm ? ` "${searchTerm}"` : ''}</b>
              </div>
            )}
          </section>
        </section>
      ) : (
        <></>
      )}
    </section>
  );
};

export default Index;
